module.exports = __webpack_public_path__ + "static/media/discountImage.aca2c9ea.png";